import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/sonner";
import { SiteContentProvider } from "@/context/SiteContentContext";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App font-sans-sc">
      <SiteContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </SiteContentProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
